import styled from 'styled-components';
import sharedStyles from '../styles';

const DescriptionArea = styled.div`
  padding: ${sharedStyles.spacing['spacing-1xl']}
    ${sharedStyles.spacing['spacing-lg']};
`;

export default DescriptionArea;
